import { Tag } from 'antd';
import { Trans } from 'react-i18next';

import useSearchParam, { UseSearchParamProps } from '../hooks/useSearchParam';

interface RangeFilterTagProps extends Omit<UseSearchParamProps, 'array'> {
  nameMin: string;
  nameMax: string;
  label: string;
}

const SalaryRangeFilterTag = ({ nameMin, nameMax, label, ...props }: RangeFilterTagProps) => {
  const [min, setMin] = useSearchParam(nameMin, props);
  const [max, setMax] = useSearchParam(nameMax, props);

  if (!(min || max)) {
    return null;
  }

  return (
    <>
      {!!min && (
        <Tag closable onClose={() => setMin('')}>
          {label} <Trans>acima de R$</Trans> {min}
        </Tag>
      )}
      {!!max && (
        <Tag closable onClose={() => setMax('')}>
          {label} <Trans>até R$</Trans> {max}
        </Tag>
      )}
    </>
  );
};

export default SalaryRangeFilterTag;
